module.exports = __webpack_public_path__ + "static/media/ice15.7b3a8f72.webp";